/**
 * Application configuration
 * Different values are used based on the current environment.
 *
 * Everything here is public: it ships in the browser bundle. The Firebase web config is
 * designed to be public; real secrets (Discogs consumer key/secret) live in Secret Manager.
 */

// Determine the environment
const isProduction = process.env.NODE_ENV === 'production';

// Base URLs
const API_URLS = {
  development: 'http://localhost:5001/discogs-c83c8/us-central1',
  production: 'https://us-central1-discogs-c83c8.cloudfunctions.net',
};

// Firebase configuration
const FIREBASE_CONFIG = {
  apiKey: 'AIzaSyCOGmPL4TM5Z5HYgWDJ0iKTgRtmKk8i8aU',
  authDomain: 'discogs-c83c8.firebaseapp.com',
  projectId: 'discogs-c83c8',
  storageBucket: 'discogs-c83c8.appspot.com',
  messagingSenderId: '638171859413',
  appId: '1:638171859413:web:4e7b47d54dd0efa609955c',
  measurementId: 'G-DYKJ1RS71L',
};

// Callback URLs
const CALLBACK_URLS = {
  development: 'http://localhost:8080/callback',
  production: 'https://discogs-c83c8.web.app/callback',
};

// Export configuration based on environment
export const config = {
  apiBaseUrl: isProduction ? API_URLS.production : API_URLS.development,
  firebase: FIREBASE_CONFIG,
  callbackUrl: isProduction ? CALLBACK_URLS.production : CALLBACK_URLS.development,
};

export default config;
